import HundredBricksAPIError from '../HundredBricksAPIError';
class PaginationError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('PaginationError', ...args);
    }
}
export default PaginationError;
